import {dom, IDisposableOwner} from 'grainjs';
import axios from 'axios';
import {buildHome, buildNameQuestion, buildRoom} from './game-dom';
import {GameModel, PlayerModel} from './game-model';

// tslint:disable:no-console

function buildPage(owner: IDisposableOwner) {
  const playerModel = PlayerModel.create(owner);
  if (!playerModel.name.get()) {
    playerModel.name.addListener((n) => n && location.reload());
    return buildNameQuestion(playerModel);
  }
  const params = new URL(location.href).pathname;
  const matches = params.match(/\/room-([^\/]+)/);
  const roomCode = matches && matches[1];
  if (!roomCode) {
    return buildHome(playerModel, createRoom, joinRoom);
  }
  return buildGame(playerModel, roomCode);
}

async function createRoom() {
  const resp = await axios.post('/room');
  const roomCode = resp.data;
  console.log("ROOM IS", roomCode);
  location.href = `/room-${roomCode}`;
}

async function joinRoom(roomCode: string) {
  console.log("Checking and joining room", roomCode);
  try {
    await axios.get(`/check-room/${roomCode}`);
  } catch (err) {
    throw new Error(err.response.data || err.response.statusText);
  }
  location.href = `/room-${roomCode}`;
}

function buildGame(playerModel: PlayerModel, roomCode: string) {
  return buildRoom(playerModel, GameModel.create(null, roomCode, playerModel));
}

dom.update(document.body, dom.create(buildPage));
